
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import authCookie from 'utils/authCookie';
import dynamic from 'next/dynamic';

const Download = dynamic(() => import('features/download'));

const DownloadDesktopPage = () => <Download />;

export async function getServerSideProps(context) {
  const isLoggedIn = Boolean(authCookie.getIsLoggedIn(context));

  return {
    props: {
      isLoggedIn,
    },
  };
}

export default DownloadDesktopPage;
